<template>
    <Form
        :errors="errors"
        :product="product"
        :product-groups-and-products="productGroupsAndProducts"
        :product-groups="productGroups"
        :dns-templates="dnsTemplates"
        :accounting-products="accountingProducts"
        :intercompany-accounting-products="intercompanyAccountingProducts"
        :fulfillment-strategies="fulfillmentStrategies"
        :is-short-termination-period-set="isShortTerminationPeriodSet"
        :invoice-behaviours="invoiceBehaviours"
        :sub-types="subTypes"
        :possible-addon-groups="possibleAddonGroups"
        :is-invoice-before-renewal-enabled="isInvoiceBeforeRenewalEnabled"
        :preselected-downgrades="preselectedDowngrades"
        :preselected-upgrades="preselectedUpgrades"
        :product-classes="productClasses"
        :termination-rules="terminationRules"
        :billing-types="billingTypes"
        :requires-domain-options="requiresDomainOptions"
        @form-submitted="submitData"
    />
</template>

<script>
import Form from '~@/Components/Products/Products/Form'

export default {
    name: 'ProductCopy',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default () {
                return {}
            }
        },
        product: {
            type: Object,
            default () {
                return {}
            }
        },
        productGroupsAndProducts: {
            type: Array,
            default () {
                return []
            }
        },
        productGroups: {
            type: Array,
            default () {
                return []
            }
        },
        dnsTemplates: {
            type: Array,
            default () {
                return []
            }
        },
        accountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        intercompanyAccountingProducts: {
            type: Array,
            default () {
                return []
            }
        },
        fulfillmentStrategies: {
            type: Array,
            default () {
                return []
            }
        },
        invoiceBehaviours: {
            type: Array,
            default () {
                return []
            }
        },
        subTypes: {
            type: Array,
            default () {
                return []
            }
        },
        isShortTerminationPeriodSet: {
            type: Boolean,
            default: () => { return false }
        },
        possibleAddonGroups: {
            type: Array,
            default: () => { return [] }
        },
        isInvoiceBeforeRenewalEnabled: {
            type: Boolean,
            default: false
        },
        preselectedDowngrades: {
            type: Array,
            default () {
                return []
            }
        },
        preselectedUpgrades: {
            type: Array,
            default () {
                return []
            }
        },
        productClasses: {
            type: Array,
            default: () => { return [] }
        },
        terminationRules: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        requiresDomainOptions: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        submitData (form) {
            const newForm = { ...form }
            newForm.selectedDowngrades = newForm.selectedDowngrades.map((val) => val.value)
            newForm.selectedUpgrades = newForm.selectedUpgrades.map((val) => val.value)

            newForm.post(this.$route('products.products.store'))
        }
    }
}
</script>
